'use client';

import Image from 'next/image';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';

export function AboutCategory({
  name,
  description,
  image,
}: {
  name?: string;
  description?: string;
  image?: string;
}) {
  if (!name || !description || !image) return null;
  return (
    <section className={cn('custom-section', 'pb-6 pt-12 sm:pb-8 md:pb-10 lg:pb-12')}>
      <div
        className={cn(
          'custom-container',
          'flex flex-col items-start justify-start gap-6 sm:gap-8 md:flex-row md:items-center md:justify-between lg:gap-12',
        )}
      >
        <div className="relative h-[251px] w-full overflow-hidden rounded-[20px] sm:h-[320px] md:max-w-[712px] lg:h-[400px] xl:h-[500px]">
          <Image
            src={image}
            alt={name}
            fill
            className="absolute inset-0 z-0 h-full w-full object-cover object-center"
          />
        </div>
        <div className="flex w-full flex-col items-start justify-start gap-4 sm:gap-5 md:max-w-[569px] lg:gap-6">
          <Heading title={name} className={{ title: 'tracking-tighter text-[#111827]' }} />
          <Paragraph
            size="base"
            className="w-full tracking-tight"
            innerHtml={description}
            color="neutral"
          />
        </div>
      </div>
    </section>
  );
}
